import { ApiRequestError } from './api';

type ToastFn = (message: string) => void;
type PlanLimitFn = (message: string, onUpgrade: () => void) => void;

interface Handlers {
  toast: ToastFn;
  showPlanLimit: PlanLimitFn;
  onUpgrade: () => void;
}

/**
 * Surface an upload failure. Plan-limit errors (storage full, file too large,
 * proof/magazine caps) open a centered, persistent dialog with an Upgrade
 * action; everything else is a transient toast.
 */
export function showUploadError(err: unknown, { toast, showPlanLimit, onUpgrade }: Handlers): void {
  const code = err instanceof ApiRequestError ? err.body?.code : undefined;
  const message = err instanceof Error ? err.message : 'Upload failed.';
  if (code?.startsWith('plan.')) {
    showPlanLimit(message, onUpgrade);
  } else {
    toast(message);
  }
}
